import {
  Error,
  ADD_Employee,
  UPDATE_Employee,
  DELETE_Employee,
  GET_Employee,
} from "../type";
const initialState = {
  AddEmployee: [],
  GetEmployee: [],
  UpdateEmployee: [],
  DeleteEmployee: [],
};
const EmployeeR = (state = initialState, action) => {
  switch (action.type) {
    case GET_Employee:
      return {
        ...state,
        GetEmployee: action.payload,
      };
    case ADD_Employee:
      return {
        GetEmployee: state.GetEmployee,
        AddEmployee: action.payload,
      };
    case UPDATE_Employee:
      return {
        GetEmployee: state.GetEmployee,
        UpdateEmployee: action.payload,
      };
    case DELETE_Employee:
      return {
        GetEmployee: state.GetEmployee,
        DeleteEmployee: action.payload,
      };
    case Error:
      return {
        GetEmployee: action.payload,
      };
    default:
      return state;
  }
};
export default EmployeeR;
